const UserStocksData = [];

export default UserStocksData;
